/**
 * Maximum age of a media message in a neighbor's send queue, see
 * `Settings.mediaSendQueueMaxAgeMs`. `?mediaSendQueueMaxAgeMs=<ms>` overrides
 * it for a session (0 = off). Resolved on the main thread and pushed into
 * the NetworkingWorker at start: the worker realm has its own Settings copy.
 */
export function resolveMediaSendQueueMaxAgeMs(search) {
    const raw = new URLSearchParams(search).get('mediaSendQueueMaxAgeMs');
    if (raw === null)
        return undefined;
    const value = Number(raw);
    return Number.isFinite(value) && value >= 0 ? value : undefined;
}
/** Browser entry point: page URL. */
export function readMediaSendQueueMaxAgeMs() {
    try {
        return resolveMediaSendQueueMaxAgeMs(window.location.search);
    }
    catch {
        return undefined;
    }
}
